export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00701.5fd3c7ef.png";